import React from 'react';

import PolicyAuditReportContainer from '@totem/components/surveyV2/policyAuditReport/policyAuditReportContainer';
import ReportTable from '@totem/components/surveyV2/policyAuditReport/ReportTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
const PolicyAuditReportPage = () => {
  return (
    <ContentLayout>
      <PolicyAuditReportContainer>
        <IBCard isCovered>
          <ReportTable />
        </IBCard>
      </PolicyAuditReportContainer>
    </ContentLayout>
  );
};

export default PolicyAuditReportPage;
